import React, { useEffect ,useState} from 'react';
import styled from 'styled-components';
import accesorios from './../images/accesorios.jpg';
import cables from './../images/cables.png';
import controles from './../images/controles.jpg';
import fichas from './../images/fichas.jpg';
import estereos from './../images/esteros.jpg';
import parlantes from './../images/parlantes.jpg';
import capacitores from './../images/capacitores.jpg';
import ProductoTable from './elementos/ProductoTable';
import BarraBuscador from './elementos/BarraBuscador';
import {  SearchIcon } from './elementos/ElementosDeBuscar';
import logo from "./../images/logo-wasap.png";


    const data = [
              { id:1, imagen: accesorios,tipo: 'Accesorios', descripcion:'Pendrives, Pilas AA, Auriculares y mas..',precio:'$consultar' },
              { id:2,imagen: cables,tipo: 'Cables', descripcion:'RCA-RCA, Rca-Iplug, Hdmi-Hdmi, kits de instalación de potencias y mas.. ', precio:'$consultar'},
              { id:3,imagen: controles,tipo: 'Controles Remotos', descripcion:'Universales y Por Marca.', precio:'$consultar' },
              { id:4,imagen: fichas,tipo: 'Fichas',descripcion:'Plug, Canon, Speakon,Jack, Adaptadores y mas..', precio:'$consultar' },
              { id:5,imagen: estereos,tipo: 'Estereos',descripcion:'Para autos , tambien los colocamos.', precio:'$consultar' },
              { id:6,imagen: parlantes,tipo: 'Parlantes',descripcion:'Personales y para autos.', precio:'$consultar' },
              { id:7,imagen: capacitores,tipo: 'Componentes Electrónicos',descripcion:'Capacitores, Reistencias, Diodos, Transistores,Pulsadores y mas', precio:'$consultar' },

            ];
            
    const ListaProductos= ()=> {
      const [productosActivos, asignarProductosActivos] = useState(data);
      const [datoABuscar, asignarDatoABuscar] = useState('');
      const [copiaProductosActivos, copiarListaProcuctosActivos] = useState(data);
      const [productosSinFiltro, asignarProductosSinFiltro] = useState(data);
  
  
      const handleChange = (e) => {
          asignarDatoABuscar(e.target.value);
          console.log(e.target.value);
          filtrarDatos();
          console.log('los productos actuales');
          console.log(productosSinFiltro);
      }
  
  
      const filtrarDatos = () => {
  
          var productosDatosFilter = datoABuscar;
          if (datoABuscar === '') {
              return (asignarProductosSinFiltro(copiaProductosActivos));
          }
          var filtrados = copiaProductosActivos.filter(
              function (el) {
                  return el.tipo.toString().toLowerCase().includes(
                    productosDatosFilter.toString().trim().toLowerCase()
                  ) ||
                      el.descripcion.toString().toLowerCase().includes(
                        productosDatosFilter.toString().trim().toLowerCase()
                      )
                      
              }
          );
          return (asignarProductosSinFiltro(filtrados));
      }

 
      useEffect(() => {
        asignarProductosActivos(data);
        copiarListaProcuctosActivos(data);
        asignarProductosSinFiltro(data);
        
    }, []);



              return (
                <>
                  
                    <Titulo>Catálogo de Productos</Titulo>
                    <Container>
        
                      <InputContainer>
                        <SearchInput type="text" placeholder="Escribe aquí..." value={datoABuscar}
                        onChange={handleChange}/>
                       
                      </InputContainer>
                    
                    </Container>
                    <ProductoTable productos={productosSinFiltro} />
                 
                 
                 
                  <ContainerLink>
                      <Link href="https://wa.me/2392528935/?text=tu%20texto%20personalizado" target="_blank">
                        <img src={logo} width="50" height="50" />
                      </Link>
                      <Text>Y mucho mas...Esperamos tu Consulta..</Text>
                  </ContainerLink>
                 
                 </>
              );
            }

    export default ListaProductos;

    const Container = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  background-color: #f0f0f0; /* Cambia el color de fondo según tus preferencias */
  padding: 10px;
  justify-content: space-between;
`;

const Titulo = styled.h3`
    display: flex;
    text-align:center;
    align-items: center;
    width: 100%;
  
`;

const InputContainer = styled.div`
  flex-grow: 1;
  display: flex;
  align-items: center;
  background-color: #fff; /* Cambia el color de fondo según tus preferencias */
  border-radius: 5px;
  padding: 5px;
`;

const SearchInput = styled.input`
  border: none;
  outline: none;
  flex-grow: 1;
  padding: 5px;
`;

const SearchButton = styled.button`
  background-color: #007bff; /* Cambia el color del botón según tus preferencias */
  color: #fff;
  border: none;
  border-radius: 5px;
  padding: 5px 10px;
  margin-left: 5px;
`;
const StyledLink = styled.a`
  display: flex;
  align-items: right;
`;

const ContainerLink = styled.div`
  width: 100%;
`;

const Link = styled.a`
  float: right;
`;

const Text = styled.div`
  float: right;
`;
